module.exports = __webpack_public_path__ + "/bundle/asset/faq-2-4-c8034f43f9e3e8a7a8250203f5b39cc1.png";